import { render } from "./RecipeRedirectPage.vue?vue&type=template&id=43e1c02b"
import script from "./RecipeRedirectPage.vue?vue&type=script&lang=js"
export * from "./RecipeRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__